import type { PreferencesSection } from './types';

/**
 * Reorder sections to match the given ID order.
 * IDs not found in `sections` are silently skipped.
 */
export const reorderSections = (
  sections: PreferencesSection[],
  newOrder: (string | number)[]
): PreferencesSection[] => {
  const byId = new Map(sections.map((s) => [s.id, s]));

  return newOrder.reduce<PreferencesSection[]>((acc, id) => {
    const section = byId.get(String(id));
    if (section) {
      acc.push(section);
    }

    return acc;
  }, []);
};

/**
 * Toggle the `enabled` flag for a section by ID.
 */
export const toggleSectionEnabled = (
  sections: PreferencesSection[],
  sectionId: string,
  enabled: boolean
): PreferencesSection[] =>
  sections.map((s) => (s.id === sectionId ? { ...s, enabled } : s));
